import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CatalogGift, Gift, GiftItem } from 'app/models/catalog-gift.model';
import { Catalog } from 'app/models/promotion-catalog.model';
import { PromotionCatalogGiftService } from 'app/services/promotion/promotion-catalog-gift.service';
import { PromotionCatalogService } from 'app/services/promotion/promotion-catalog.service';
import { MessageService, SelectItem } from 'primeng/primeng';


@Component({
  selector: 'app-catalogo-premi',
  templateUrl: './catalogo-premi.component.html',
  styleUrls: ['./catalogo-premi.component.css']
})
export class CatalogoPremiComponent implements OnInit {

  @Input() customerId: any;
  preferredGiftList: Array<Catalog> = [];
  catalogList: Array<Catalog> = [];
  catalogListCombo: SelectItem[] = [];
  giftsListCombo: SelectItem[] = [];
  giftsListShow: Array<Gift> = [];
  showAddCards = false;
  catalogToAdd: Catalog;
  public showAddCatalogGift = false;
  selectedCatalog: any = null;
  selectedGift: any = null;
  showDeletePreferredGift = false;
  selectGiftToDelete: CatalogGift = null;
  selectGiftToDeleteForEdit: CatalogGift = null;
  modeEdit = false;

  paramsGiftList: any[] = [];
  constructor(
    private catalogService: PromotionCatalogService,
    private catalogGiftService: PromotionCatalogGiftService,
    private messageService: MessageService,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef // Iniezione di ChangeDetectorRef

  ) {
    this.paramsGiftList.push({
      key: 'flg_state',
      value: '0'
    }, {
      key: 'dt_validity',
      value: true})

  }

  ngOnInit() {
    this.getCatalogList();
  }

  getPreferredGifts(catalog: CatalogGift) {


    this.catalogService.getCatalogPreferredGift(this.customerId, catalog.id).subscribe((res) => {
      //Cerco il catalogo associato al premio preferito
      if (res) {
        let app: CatalogGift = {
          code: catalog.code,
          description: catalog.description,
          flg_state: catalog.flg_state,
          id: catalog.id,
          giftList: [],
          barcode_cont_pickup: '',
          barcode_nocont_pickup: '',
          dt_start: '',
          dt_end: ''
        };
        app.giftList.push(catalog.giftList.find(g => g.id === res.giftId));
        app.giftList[0].item = [];
        this.catalogGiftService.getCatalogGiftItemData(res.giftId).subscribe((res2) => {
          if(res2)
          {
            res2.forEach(start =>{
              let appItemGift: GiftItem = {
                id: start.id,
                rdm_points: start.rdm_points,
                rdm_value: start.rdm_value
            };
              app.giftList[0].item.push(appItemGift);
            })
          }
          this.preferredGiftList.push(app);
        })
      } else {
        console.debug("non ci sono premi preferiti per il catalogo " + catalog.id)
      }

    });

  }

  showAddCatalogGiftModal() {
    this.selectedCatalog = null;
    this.selectedGift = null;
    this.showAddCatalogGift = true;
    this.modeEdit = false;
  }

  inizializeCatalogCombo() {
    this.catalogListCombo = [];
    this.catalogListCombo.push({ value: null, label:  this.translate.instant('catalog.selectCatalog') });
    this.giftsListCombo = [];
  }

  getCatalogList() {
    this.inizializeCatalogCombo();
    this.catalogService.list(null, null, this.paramsGiftList, null, "code",1).subscribe((res) => {
      if (res) {
        this.catalogList = res.data; // array cataloghi disponibili
        res.data.forEach(catalog => {
          catalog.giftList = new Array<any>();
          //mi creo l'array con tutti i valori dei cataloghi presenti per popolare la combo
          this.catalogListCombo.push({
            value: catalog.id,
            label: catalog.code + ' - ' + catalog.description
          })

          this.catalogGiftService.catalogId = catalog.id;
          //carico la lista dei premi per ogni catalogo
          this.catalogGiftService.list(null, null, this.paramsGiftList,null, "description",1).subscribe((res) => {
            if (res) {
              catalog.giftList = res.data;
              this.getPreferredGifts(catalog);

              /*res.data.forEach(start =>
              {
                this.giftsListCombo.push({
                  value: start.id,
                  label: start.itm_code + ' - ' + start.description
                })
              })*/
            }
          });

        })
      } else {
        this.messageService.add({
          severity: 'info',
          summary:  this.translate.instant('common.success'),
          detail:  this.translate.instant('catalog.catalogNotPresent'), });

      }
    });

  }

  showEditPreferGift(preferredGift: CatalogGift) {


      this.catalogGiftService.catalogId = preferredGift.id;
      this.catalogGiftService.list(null, null, this.paramsGiftList, null, "description",1).subscribe((res) => {
        res.data.forEach(start =>
          this.giftsListCombo.push({
            value: start.id,
            label: start.itm_code + ' - ' + start.description
          }))
          this.selectedCatalog = preferredGift.id;
          this.selectedGift = preferredGift.giftList[0].id;
          this.modeEdit = true;
          this.selectGiftToDeleteForEdit = preferredGift;
          this.showAddCatalogGift = true;
      })

  }


  showDeletePreferGift(preferredGift: CatalogGift) {
    this.showDeletePreferredGift = true;
    this.selectedCatalog = preferredGift.id;
    this.selectGiftToDelete = preferredGift;
  }

  deletePreferGift(preferredGift: any) {
    //TODO Inserire logca di cancellazione preferito
    this.catalogService.deletePreferredGift(this.customerId, this.selectedCatalog).subscribe((res) => {
      this.showDeletePreferredGift = false;
      //if(res){
      //this.preferredGiftList.splice(this.preferredGiftList.indexOf(preferredGift), 1);
      const index = this.preferredGiftList.indexOf(this.selectGiftToDelete);
      if (index > -1) {
        this.preferredGiftList.splice(index, 1); // Rimuovi l'elemento dall'array
      }
      this.getCatalogList();
      this.changeDetectorRef.detectChanges()
      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('common.success'),
        detail: this.translate.instant('common.operation_success')
      });
      this.selectGiftToDelete = null
      //}
      /*else{
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('common.error')
        });
      }*/
    })
  }


  selectCatalog(event) {
    this.giftsListCombo = []
    this.catalogGiftService.catalogId = event.value;
    this.catalogGiftService.list(null, null, this.paramsGiftList,null, "description",1).subscribe((res) => {
      res.data.forEach(start =>
        this.giftsListCombo.push({
          value: start.id,
          label: start.itm_code + ' - ' + start.description
        }))
    })

  }

  validateAddEditPreferGift() {
    let catalog = this.preferredGiftList.find(c => c.id === this.selectedCatalog)
    if (catalog && catalog.id > 0) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('catalog.errorAddCatalogAlreadyPresent')
      });
      return true
    }
    return false
  }

  addPreferGift() {

    if(this.selectGiftToDeleteForEdit && this.selectGiftToDeleteForEdit.giftList[0].id == this.selectedGift){
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('catalog.notSameGift')
      });
      return
    }
    if (!this.modeEdit && this.validateAddEditPreferGift()) {
      return;
    }
    let data =
    {
      "customerId": this.customerId,
      "catalogId": this.selectedCatalog,
      "giftId": this.selectedGift
    }
    this.catalogService.editPreferredGift(data).subscribe((res) => {
      //Cerco il catalogo associato al premio preferito
      //if(res){
      if(this.modeEdit){
        const index = this.preferredGiftList.indexOf(this.selectGiftToDeleteForEdit);
      if (index > -1) {
        this.preferredGiftList.splice(index, 1); // Rimuovi l'elemento dall'array per la renderizzazione
      }
      }
      this.getCatalogList();
      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('common.success'),
        detail: this.translate.instant('common.operation_success')
      });
      this.selectGiftToDeleteForEdit = null;
      //}
      /*else{
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('common.error')
        });
      }*/
    });
    this.showAddCatalogGift = false;

  }

  closeAddPreferGift() {
    this.showAddCatalogGift = false;
    if(!this.modeEdit)
      this.giftsListCombo = [];
    this.selectGiftToDeleteForEdit = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/catalogo-premi/catalogo-premi.component.ts